// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CompromissosServicos_SalvaCompromissoServicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos_servicos/salvaCompromissoServico
 *
 * Updates an existing compromisso_servico record.
 *
 * Data shape: boolean true on success
 *
 * @see Compromissos_servicos::salvaCompromissoServico()
 * @see Atendente_interactor::AlteraServicoCompromisso()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type CompromissosServicos_SalvaCompromissoServicoResponseDados = boolean;

export type CompromissosServicos_SalvaCompromissoServicoResponse = ApiResponse<CompromissosServicos_SalvaCompromissoServicoResponseDados>;

registerResponseContract('CompromissosServicos_SalvaCompromissoServicoResponse', {})
